import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    assets: null,
    loading: false,
    error: null,
    search: '',
    pageNumber: 1,
    pageSize: 10,
    filteredColumns: []
};
export const fetchAssets = createAsyncThunk('assetsDetail/fetchAssets', async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const { search, pageNumber, pageSize, filteredColumns } = state.assetsDetail;
    const params = {
        searchString: search,
        pageNumber,
        pageSize,
        filteredColumns
    };
    try {
        const response = await itwApi.post('assets/get-assets-detail', params);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch assets');
    }
});
export const assetSlice = createSlice({
    name: 'assetsDetail',
    initialState,
    reducers: {
        clearAssets: (state) => {
            state.assets = null;
        },
        clearFilters: (state) => {
            state.filteredColumns = [];
        },
        setSearch: (state, action) => {
            state.search = action.payload;
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setAddFilter: (state, action) => {
            if (action.payload.length === 0) {
                state.filteredColumns = [];
                return;
            }
            state.filteredColumns = action.payload.filter((filter) => !action.payload.some((newFilter) => newFilter.key === filter.key && newFilter.value === ''));
            state.filteredColumns.forEach((newFilter) => {
                const existingIndex = action.payload.findIndex((filter) => filter.key === newFilter.key);
                if (existingIndex !== -1) {
                    state.filteredColumns[existingIndex].value = newFilter.value;
                }
                else {
                    state.filteredColumns.push(newFilter);
                }
            });
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAssets.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchAssets.fulfilled, (state, action) => {
            state.loading = false;
            state.assets = action.payload;
        })
            .addCase(fetchAssets.rejected, (state, action) => {
            state.loading = false;
            state.error = null;
        });
    }
});
export const { clearAssets, setSearch, clearFilters, setPageNumber, setPageSize, setAddFilter } = assetSlice.actions;
export default assetSlice.reducer;
